<template>
  <div>
    <el-row :gutter="10" class="u-mt-10 u-mb-20">
      <el-col :xs="24" :sm="10">
        <el-input v-model="filtro[campoBusca]" :placeholder="placeholderBusca" clearable
                  @keyup.native.enter="load" @clear="load"></el-input>
      </el-col>

      <el-col :xs="24" :sm="6" v-if="filtroExtra">
        <el-select v-model="filtro[filtroExtra.chave]" :placeholder="filtroExtra.label" clearable
                   @change="load" style="width:100%" filterable>
          <el-option v-for="o in (filtroExtra.opcoes || opcoesDinamicas[filtroExtra.chave] || [])"
                     :key="o.valor" :label="o.rotulo" :value="o.valor"></el-option>
        </el-select>
      </el-col>

      <el-col :xs="24" :sm="filtroExtra ? 8 : 14" class="u-text-right">
        <el-button class="u-mr-10" @click="load" type="info" plain icon="el-icon-search">FILTRAR</el-button>
        <el-button v-if="podeEscrever" type="primary" icon="el-icon-plus" @click="abrirNovo">{{ rotuloNovo }}</el-button>
      </el-col>
    </el-row>

    <div class="container-table">
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="hidden-mobile" style="width:70px;">cod</th>
            <th v-for="c in colunas" :key="c.chave" :style="c.largura ? 'width:' + c.largura : ''"
                :class="c.mobileOculto ? 'hidden-mobile' : ''">{{ c.label }}</th>
            <th class="hidden-mobile u-text-center" style="width:80px;">Ativo</th>
            <th style="width:130px;" class="u-text-center" v-if="podeEscrever">Ação</th>
          </tr>
        </thead>
        <tbody v-if="statusList">
          <tr v-for="item in items" :key="item.id">
            <td class="hidden-mobile">{{ item.id }}</td>
            <td v-for="c in colunas" :key="c.chave" :class="c.mobileOculto ? 'hidden-mobile' : ''">
              {{ formatar(item, c) }}
            </td>
            <td class="hidden-mobile u-text-center">{{ item.situacao ? 'SIM' : 'NÃO' }}</td>
            <td class="u-text-center acao" v-if="podeEscrever">
              <el-button @click="abrirEdicao(item)" title="Editar" type="info" icon="el-icon-edit"
                         size="mini" plain class="u-mr-10"></el-button>
              <el-button @click="excluir(item)" title="Excluir" type="danger" icon="el-icon-delete"
                         size="mini" plain></el-button>
            </td>
          </tr>
          <tr v-if="items.length === 0">
            <td :colspan="colunas.length + (podeEscrever ? 3 : 2)" class="u-text-center">
              Nenhum registro encontrado.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <el-dialog :title="(editandoId ? 'Editar ' : 'Novo ') + nomeSingular" :visible.sync="dialogAberto"
               :width="dialogLargura" append-to-body>
      <el-form :model="form" label-position="top">
        <el-row :gutter="10">
          <el-col v-for="c in campos" :key="c.chave" :xs="24" :sm="c.span || 12">
            <el-form-item :label="c.label + (c.obrigatorio ? ' *' : '')">
              <el-select v-if="c.tipo === 'select'" v-model="form[c.chave]" :clearable="!c.obrigatorio"
                         :placeholder="c.label" style="width:100%" filterable>
                <el-option v-for="o in (c.opcoes || opcoesDinamicas[c.chave] || [])" :key="o.valor"
                           :label="o.rotulo" :value="o.valor"></el-option>
              </el-select>

              <el-switch v-else-if="c.tipo === 'switch'" v-model="form[c.chave]"></el-switch>

              <el-input v-else-if="c.tipo === 'numero'" v-model="form[c.chave]" type="number"></el-input>

              <el-input v-else v-model="form[c.chave]" :maxlength="c.max"></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12">
            <el-form-item label="Ativo"><el-switch v-model="form.situacao"></el-switch></el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer">
        <el-button @click="dialogAberto = false">CANCELAR</el-button>
        <el-button class="u-ml-10" type="primary" @click="salvar" :loading="salvando">SALVAR</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/**
 * CRUD genérico para cadastros simples, parametrizado pela URL COMPLETA.
 *
 * Nasceu no Bloco Z do Transporte, onde três cadastros do edital (marca, modelo e tipo de
 * usuário) têm a mesma mecânica. A diferença para o `catalogo-crud` da Biblioteca é que
 * aquele é amarrado ao endpoint `api/biblioteca/catalogo/{tipo}`; este recebe a base pronta,
 * e serve a qualquer módulo.
 *
 * `podeEscrever` só decide se o botão aparece — a regra real está no Service, que recusa de
 * qualquer forma. Esconder botão não é segurança.
 */
export default {
  name: 'CrudSimples',

  props: {
    /** Base completa, sem a ação. Ex.: 'api/transporte-escolar/marca'. */
    endpoint: { type: String, required: true },

    rotuloNovo: { type: String, default: 'NOVO' },
    nomeSingular: { type: String, default: 'registro' },
    placeholderBusca: { type: String, default: 'Pesquisar' },
    campoBusca: { type: String, default: 'nome' },

    campos: { type: Array, required: true },
    colunas: { type: Array, required: true },
    filtroExtra: { type: Object, default: null },

    /** Espelho da matriz do backend. */
    perfisEscrita: { type: Array, default: () => [4, 5] },

    dialogLargura: { type: String, default: '600px' }
  },

  data () {
    return {
      statusList: false, salvando: false, dialogAberto: false,
      items: [], filtro: {}, form: {}, editandoId: null, opcoesDinamicas: {}
    }
  },

  computed: {
    podeEscrever () { return this.perfisEscrita.indexOf(Number(this.$store.state.user.tipo)) !== -1 },
    base () { return `${this.$store.state.config.baseUrlApi}/${this.endpoint}` }
  },

  mounted () {
    this.$set(this.filtro, this.campoBusca, '')
    if (this.filtroExtra) this.$set(this.filtro, this.filtroExtra.chave, '')
    this.load()
    this.carregarOpcoesDinamicas()
  },

  methods: {
    formatar (item, c) {
      let v = item[c.chave]

      if (c.caminho) {
        v = c.caminho.split('.').reduce((o, k) => (o && o[k] !== undefined ? o[k] : null), item)
      }

      // Ausência é ausência: travessão, não zero nem string vazia.
      if (v === null || v === undefined || v === '') return '—'

      if (c.booleano) return v ? 'SIM' : 'NÃO'
      if (c.mapa) return c.mapa[v] || v

      return v
    },

    load () {
      this.statusList = false
      this.items = []

      this.$axios.post(`${this.base}/getAllPaginate`, this.filtro, this.$store.getters.getHeaderAuth)
        .then(r => {
          this.statusList = true

          if (r.data && r.data.erro) {
            return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          }

          this.items = r.data.data || []
        })
        .catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
    },

    /** Campos cujas opções vêm de outro endpoint (ex.: a marca do modelo). */
    carregarOpcoesDinamicas () {
      const alvos = this.campos.filter(c => c.opcoesDe)

      if (this.filtroExtra && this.filtroExtra.opcoesDe) alvos.push(this.filtroExtra)

      alvos.forEach(c => {
        this.$axios.post(`${this.$store.state.config.baseUrlApi}/${c.opcoesDe}/getAllPaginate`,
                         { per_page: 200 }, this.$store.getters.getHeaderAuth)
          .then(r => {
            if (!r.data || r.data.erro) return

            this.$set(this.opcoesDinamicas, c.chave, (r.data.data || []).map(i => ({
              valor: i.id, rotulo: i.nome || i.descricao
            })))
          }).catch(() => {})
      })
    },

    abrirNovo () {
      this.editandoId = null
      const f = { situacao: true }
      this.campos.forEach(c => { f[c.chave] = c.padrao !== undefined ? c.padrao : (c.tipo === 'switch' ? false : '') })
      this.form = f
      this.dialogAberto = true
    },

    abrirEdicao (item) {
      this.editandoId = item.id
      const f = { situacao: !!item.situacao }
      this.campos.forEach(c => {
        const v = item[c.chave]
        f[c.chave] = c.tipo === 'switch' ? !!v : (v === null || v === undefined ? '' : v)
      })
      this.form = f
      this.dialogAberto = true
    },

    salvar () {
      const faltando = this.campos.filter(c => c.obrigatorio &&
        (this.form[c.chave] === '' || this.form[c.chave] === null || this.form[c.chave] === undefined))

      if (faltando.length) {
        return window.eventBus.$emit('alert', {
          msg: 'Preencha: ' + faltando.map(c => c.label).join(', ') + '.', type: 'warning'
        })
      }

      this.salvando = true
      const url = this.editandoId ? `${this.base}/update/${this.editandoId}` : `${this.base}/store`

      this.$axios.post(url, this.form, this.$store.getters.getHeaderAuth)
        .then(r => {
          this.salvando = false

          if (r.data && r.data.erro) {
            return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          }

          this.dialogAberto = false
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.load()
          this.carregarOpcoesDinamicas()
        })
        .catch(e => { this.salvando = false; this.$store.commit('throwException', e) })
    },

    excluir (item) {
      this.$msgbox.confirm(`Tem certeza que deseja excluir este ${this.nomeSingular}?`, 'Atenção',
        { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
        .then(() => {
          this.$axios.delete(`${this.base}/delete/${item.id}`, this.$store.getters.getHeaderAuth)
            .then(r => {
              if (r.data && r.data.erro) {
                return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
              }

              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.load()
            })
            .catch(e => this.$store.commit('throwException', e))
        })
        .catch(() => {})
    }
  }
}
</script>
